export default "__VITE_ASSET__C1R2Nsu4__"